import Profile from "./Profile";

const routes = [{
  path: 'profile',
  name: 'profile',
  component: Profile,
  meta: {requiresAuth: true}
}];

export {routes}
